<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data Role" subTitle="Forms" />

    <ListRoleGroup />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import ListRoleGroup from "@/components/Pages/Master/RoleGroup/ListRoleGroup.vue";

export default defineComponent({
  name: "ListRoleGroupPage",
  components: {
    PageTitle,
    ListRoleGroup,
  },
});
</script>
